import type { RPoly2 } from "@aec-craft/nb-generative-core";
import z, { type ZodType } from "zod";

export interface MassingPreview {
	plotBoundaries: RPoly2[];
	buildingBoundaries: RPoly2[];
}

const zV2 = z.object({
	x: z.number().readonly(),
	y: z.number().readonly(),
});

const zPoly2 = z.array(zV2).readonly();

export const zMassingPreview = z.object({
	plotBoundaries: z.array(zPoly2),
	buildingBoundaries: z.array(zPoly2),
}) satisfies ZodType<MassingPreview>;
